import { isDifferentDays } from "@hudson/ui/lib/date_fns_locale";
import Flight from "./Flight";
import PassengersAndExtras from "./PassengersAndExtras";
import PickupDate from "./PickupDate";
import PickupAndDropoff from "./PickupDropoff";
import ResId from "./ResId";
import Service from "./Service";
import Actions, { Action } from "./Actions";
import useConfig from "@lib/use_config";
import classNames from "classnames";

export { PassengersAndExtras, PickupAndDropoff };

function Reservation({
  actions = [],
  hideLocationString = false,
  hideSubFares = false,
  repricing = false,
  res,
  serviceArea,
  shiftPickupDropoff = false,
  vertical,
}: {
  actions?: Action[];
  hideLocationString?: boolean;
  hideSubFares?: boolean;
  repricing?: boolean;
  res: be.Reservation;
  serviceArea?: number;
  shiftPickupDropoff?: boolean;
  vertical?: boolean;
}): JSX.Element | null {
  const { data, error, loading } = useConfig(["currency", "openReservationMode", "timeFormat"]);

  if (error || loading) return null;

  return (
    <>
      <div
        className={classNames(
          "gap-y-4 flex",
          vertical ? "ml-6 flex-col" : "flex-row gap-x-8 items-end justify-between",
        )}
      >
        <div className="flex flex-col gap-y-4">
          <div className="flex flex-col gap-y-0">
            <ResId
              className="font-title font-bold tracking-wide rounded-br-lg text-lg"
              id={res.resId}
            />
            {(!res.open || data?.config.openReservationMode == "enabled_collect_date") && (
              <PickupDate
                className="text-lg text-gray-800"
                date={res.service?.selectedTime?.pickupTime}
              />
            )}
          </div>

          {res.dropoff && res.pickup && (
            <PickupAndDropoff
              dropoff={res.dropoff}
              pickup={res.pickup}
              stops={res.stops}
              hideString={hideLocationString}
              shiftLeft={shiftPickupDropoff}
            />
          )}
        </div>

        <hr className={`h-px mt-4 bg-gray-200 border-0 ${vertical ? "block" : "hidden"}`} />

        <div className="flex flex-wrap items-center justify-between gap-y-3 gap-x-8 px-4">
          {res.flight && !res.customerRequest && (
            <Flight
              flight={res.flight}
              showDay={
                !!(
                  res.service?.selectedTime?.dropoffTime &&
                  res.service?.selectedTime?.pickupTime &&
                  isDifferentDays(
                    res.service.selectedTime?.dropoffTime,
                    res.service.selectedTime?.pickupTime,
                    res.flight.flightTime,
                  )
                )
              }
              timeFormat={data?.config.timeFormat}
            />
          )}

          <PassengersAndExtras res={res} serviceArea={serviceArea} vertical={true} />
        </div>

        <hr className={`h-px mb-0 bg-gray-200 border-0 ${vertical ? "block" : "hidden"}`} />

        {res.service && (
          <Service
            currency={data?.config.currency}
            hideSubFares={hideSubFares}
            isRepricing={repricing}
            service={res.service}
            showPickupTime={!!(res.service?.selectedTime?.customerSelected || res.resId)}
            timeFormat={data?.config.timeFormat}
            vertical={vertical}
          />
        )}

        <div className="mx-4 mb-4 mt-3 self-center">
          {actions.length > 0 && <Actions actions={actions} />}
        </div>
      </div>
    </>
  );
}

export default Reservation;
export type { Action };
